import React from "react";

import TextField, { TextFieldProps } from "@material-ui/core/TextField";
import {
	AuBankAccountElement,
	CardCvcElement,
	CardExpiryElement,
	CardNumberElement,
	FpxBankElement,
	IbanElement,
	IdealBankElement
} from "@stripe/react-stripe-js";

import { StripeInput } from "./StripeInput";

type StripeElement =
	| typeof AuBankAccountElement
	| typeof CardCvcElement
	| typeof CardExpiryElement
	| typeof CardNumberElement
	| typeof FpxBankElement
	| typeof IbanElement
	| typeof IdealBankElement;

interface StripeTextFieldProps<T extends StripeElement>
	extends Omit<TextFieldProps, "onChange" | "inputComponent" | "inputProps"> {
	onChange?: React.ComponentProps<T>["onChange"];
	inputProps?: React.ComponentProps<T>;
	stripeElement: T;
}

const StripeTextField = <T extends StripeElement>(props: StripeTextFieldProps<T>) => {
	const { InputLabelProps, stripeElement, InputProps = {}, inputProps, ...other } = props;

	return (
		<TextField
			fullWidth
			InputLabelProps={{
				...InputLabelProps,
				shrink: true
			}}
			InputProps={{
				...InputProps,
				inputProps: {
					...inputProps,
					...InputProps.inputProps,
					component: stripeElement
				},
				inputComponent: StripeInput
			}}
			variant="outlined"
			{...(other as any)}
		/>
	);
};

export default StripeTextField;
